import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20light%20airy%20lifestyle%20composition%20featuring%20an%20arrangement%20of%20beautiful%20pastel%20toned%20fashion%20accessories%20and%20home%20goods%20on%20a%20warm%20cream%20linen%20surface%2C%20a%20soft%20sage%20green%20silk%20scarf%2C%20delicate%20gold%20toned%20jewelry%2C%20a%20ceramic%20vase%20with%20dried%20eucalyptus%2C%20and%20a%20leather%20bound%20journal%2C%20diffused%20morning%20sunlight%20from%20a%20large%20window%20creating%20gentle%20shadows%2C%20warm%20terracotta%20and%20blush%20pink%20accents%2C%20Scandinavian%20minimalist%20aesthetic%20with%20thoughtful%20negative%20space%2C%20editorial%20product%20photography%20with%20shallow%20depth%20of%20field%20and%20dreamy%20atmosphere&width=1600&height=900&seq=hero-bg-vigorbuy-v3&orientation=landscape"
          alt="VigorBuy Spreadsheet - Modern fashion and lifestyle products showcase"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full section-container text-center flex flex-col items-center py-16 md:py-20">
        <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium mb-6 tracking-wide uppercase"
          style={{ backgroundColor: 'oklch(var(--accent-500) / 0.2)', color: 'oklch(var(--accent-100))' }}>
          Complete Resource Guide 2026
        </span>

        <h1 className="font-heading font-bold text-3xl md:text-5xl lg:text-6xl mb-5 max-w-3xl leading-tight" style={{ color: 'oklch(var(--background-50))' }}>
          Master Data Management With{' '}
          <span style={{ color: 'oklch(var(--accent-300))' }}>VigorBuy Spreadsheet</span>
        </h1>

        <p className="text-base md:text-lg max-w-2xl mb-8 leading-relaxed" style={{ color: 'oklch(var(--background-50) / 0.85)' }}>
          Explore VigorBuy Spreadsheet features, templates, alternatives, security information, and practical
          tutorials designed to help individuals and businesses improve productivity and streamline data workflows.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 mb-6">
          <Link
            to="/vigorbuy-spreadsheet-guide"
            className="btn-primary text-sm px-8 py-3.5 rounded-lg font-semibold"
          >
            <i className="ri-book-open-line mr-2"></i>
            Read Complete Guide
          </Link>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center px-8 py-3.5 rounded-lg font-semibold text-sm whitespace-nowrap cursor-pointer transition-all duration-200 border-2"
            style={{
              borderColor: 'oklch(var(--background-50) / 0.5)',
              color: 'oklch(var(--background-50))',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'oklch(var(--background-50) / 0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            <i className="ri-external-link-line mr-2"></i>
            VigorBuy Spreadsheet
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-xs" style={{ color: 'oklch(var(--background-50) / 0.7)' }}>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-sm" style={{ color: 'oklch(var(--accent-400))' }}></i>
            Detailed Reviews
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-sm" style={{ color: 'oklch(var(--accent-400))' }}></i>
            Feature Comparisons
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-sm" style={{ color: 'oklch(var(--accent-400))' }}></i>
            Security Analysis
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-sm" style={{ color: 'oklch(var(--accent-400))' }}></i>
            Expert Guides
          </span>
        </div>
      </div>
    </section>
  );
}